module.exports = __webpack_public_path__ + "static/media/BackArrow.710f0961.svg";